import { render, staticRenderFns } from "./SampleManagement.vue?vue&type=template&id=35896b14&"
import script from "./SampleManagement.vue?vue&type=script&lang=js&"
export * from "./SampleManagement.vue?vue&type=script&lang=js&"
import style0 from "./SampleManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports